<template>
    <div class="card-body">
        <b-container v-if="metodos_pago_eventos && metodos_pago_abonos_bases">
            <div class="form" v-if="!loading_metodos_pago_eventos && !loading_metodos_pago_abonos_bases">
                <b-row>
                    <b-col>
                        <div class="form-group mt-5">
                            <label for="">Métodos de pago de Eventos</label>
                            <multiselect 
                                v-model="select_metodos_pago_eventos"
                                placeholder="Selecione Metodos de Pago"
                                label="nombre"
                                track-by="id"
                                :options="metodos_pago_eventos"
                                :multiple="true"
                            >
                            </multiselect>
                        </div>
                        
                        <div class="form-group mt-5">
                            <label for="metodos_pago_abonos">Métodos de pago de Abonos y Deportistas</label>
                            <multiselect 
                                v-model="select_metodos_pago_abonos_bases"
                                placeholder="Selecione Metodos de Pago"
                                label="nombre"
                                track-by="id"
                                id="metodos_pago_abonos"
                                :options="metodos_pago_abonos_bases"
                                :multiple="true"
                            >
                            </multiselect>
                        </div>  
                    </b-col>
                    <b-col cols="12" class="mt-5">
                        <button class="btn" @click="guardar">Guardar</button> 
                    </b-col>
                </b-row>
            </div>
        </b-container>
    </div>
</template>

<script>
export default {
    data() {
        return {
            select_metodos_pago_eventos: [],
            select_metodos_pago_abonos_bases: [],
            metodos_pago_eventos: [],
            metodos_pago_abonos_bases: [],
            loading_metodos_pago_eventos: false,
            loading_metodos_pago_abonos_bases: false,
        }
    },
    created() {
        this.getMetodosPagoAbonosBases();
        this.getMetodosPagoEventos()

    },
    computed: {
        teatro() {
            return this.$store.getters.getTeatro;
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
    },
    methods: {
        getMetodosPagoEventos() {
            var params = {
                filters: {
                    teatro_id: this.teatro.id
                },
                teatro_id: this.teatro.id
            }
            this.$store.dispatch(this.config.getVuexAlias('back.metodos-pago-eventos'), params).then(res => {
                this.metodos_pago_eventos = res.data.data;

                this.select_metodos_pago_eventos = this.teatro.metodos_pago_eventos;
            });
        },
        getMetodosPagoAbonosBases() {
            var params = {
                filters: {
                    teatro_id: this.teatro.id
                },
                teatro_id: this.teatro.id
            }
            this.$store.dispatch(this.config.getVuexAlias('back.metodos-pago-abonos-abase'), params).then(res => {
                this.metodos_pago_abonos_bases = res.data.data;

                this.select_metodos_pago_abonos_bases = this.teatro.metodos_pago_abonos_bases;
            });
        },
        guardar(){
            this.updateMetodosPagoEventos();
            this.updateMetodosPagoAbonosBases();
        },
        updateMetodosPagoEventos(){
            this.loading_metodos_pago_eventos = true;
            var params = {
                filters: {},
                metodos_pago_eventos_select: this.select_metodos_pago_eventos,
            }
            this.$store.dispatch(this.config.getVuexAlias('back.metodos-pago-eventos.update'), params).catch(err => {
                this.$toast.error(err.response.data.message);
            }).then(res => {
                this.$toast.success(res.data.message);
            }).finally(() => {
                this.updateSettings();
                this.loading_metodos_pago_eventos = false;
            })
        },
        updateMetodosPagoAbonosBases(){
            this.loading_metodos_pago_abonos_bases = true;
            var params = {
                filters: {},
                metodos_pago_abonos_bases_select: this.select_metodos_pago_abonos_bases,
            }
            this.$store.dispatch(this.config.getVuexAlias('back.metodos-pago-abonos-abase.update'), params).catch(err => {
                this.$toast.error(err.response.data.message);
            }).then(res => {
                this.$toast.success(res.data.message);
            }).finally(() => {
                this.updateSettings();
                this.loading_metodos_pago_abonos_bases = false;
            })
        },
        updateSettings(){
            
            const params = {
                filters : {
                    tid : this.configuracion.hash_teatro
                }
            }
            this.$store.dispatch(this.config.getVuexAlias('settings'), params).then(res => {
                this.select_metodos_pago_abonos_bases = this.teatro.metodos_pago_abonos_bases;
                this.select_metodos_pago_eventos = this.teatro.metodos_pago_eventos;
            })
        }
    },
}
</script>